<template>
  <div class="mb-4">
    <div class="row">
      <div class="col-12 col-md-6 offset-md-3 mt-5">
        <ChangePassword></ChangePassword>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePassword from '@/components/Widgets/ChangePassword/ChangePassword.vue';
export default {
  name: 'Products',
  components: {
    ChangePassword,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>